export default import.meta.ROLLDOWN_FILE_URL_u5WPRRS5zEL$Fqpf5qVGlw